<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol" aria-hidden="true">
    <title>Account</title>
    <path
      fill="currentColor"
      d="M12 12c-1.6 0-3.1-.6-4.2-1.8C6.6 9.1 6 7.6 6 6s.6-3.1 1.8-4.2C8.9.6 10.4 0 12 0s3.1.6 4.2 1.8C17.4 2.9 18 4.4 18 6s-.6 3.1-1.8 4.2C15.1 11.4 13.6 12 12 12zm0-9.6c-1 0-1.9.4-2.5 1.1C8.8 4.1 8.4 5 8.4 6s.4 1.9 1.1 2.5c1.4 1.4 3.7 1.4 5.1 0 .6-.6 1-1.5 1-2.5s-.4-1.9-1.1-2.5c-.6-.7-1.6-1.1-2.5-1.1zm3.4 7zM20.4 24H3.6c-.7 0-1.2-.5-1.2-1.2 0-2.6 1-5 2.8-6.8 1.8-1.8 4.2-2.8 6.8-2.8s5 1 6.8 2.8c1.8 1.8 2.8 4.2 2.8 6.8 0 .7-.5 1.2-1.2 1.2zM4.9 21.6h14.2c-.2-1.5-.9-2.8-2-3.9-1.4-1.4-3.2-2.1-5.1-2.1-1.9 0-3.7.7-5.1 2.1-1.1 1.1-1.8 2.4-2 3.9zm1.2-4.7z"
    />
  </svg>
</template>
